import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Menu, Pagination, Select } from "antd";
import { notification, Spin } from "antd";
import { Delete, EditIcon } from "components/icons";
import { Field, Form, Formik } from "formik";
import { uniqBy } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";
import { convertIsoDateToStandardFormat } from "utils/date";

import AccessControl from "../../../components/common/AccessControl/accessControl";
import ManageAccess from "../../../components/common/ManageAccess/manageAccess";
import DeleteModal from "../../../components/common/Modals/component";
import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import amplitude from "../../../externals/amplitude";
import { addTournamentValidation, editTournamentValidation } from "../../../utils/validations";
const { Option } = Select;

const AddTournaments = (props) => {
  const firstRef = useRef(true);
  const teamsRef = useRef(true);
  const { user, clientSetting, entityId } = useOutletContext();
  const {
    loder,
    getTournaments,
    tournamentList,
    addBulkTournament,
    setSearch,
    setCount,
    count,
    search,
    // getCategorys,
    getCreateTournament,
    getAllTeams,
    getEditTournament,
    getDeleteTournament,
    getTotalTeams,
    getAllCategory,
    selectedCategories,
    tournamentCount,
    id,
    getEntityTypes,
    ENTITY_TYPE,
  } = props;
  const [teams, setTeams] = useState([]);
  const [teamsEdit, setTeamsEdit] = useState([]);

  const [csvmodalIsOpen, setcsvIsOpen] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [category, setCategory] = useState("");
  const [selectCategory, setSelectCategory] = useState("");
  const [delmodalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [tournamentLoader, setTournamentLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [teamSearch, setTeamSearch] = useState("");
  const [editData, setEditData] = useState("");
  const [limit, setLimit] = useState(20);
  const [getCategorys, setCategorys] = useState([]);

  const disallowRosterMutation = useMemo(() => {
    return clientSetting?.permissions?.disableRosterMutation;
  }, [clientSetting?.permissions?.disableRosterMutation]);

  const openEdit = (editData) => {
    setEditData(editData);
    getTeamsForEdit(selectCategory, editData);
  };
  const getTeamsForEdit = async (selectCategory, editData) => {
    const categoryId = await getCategorys?.filter((data) => data.name == selectCategory);
    const { value } = await getTotalTeams({
      search: "",
      category: categoryId[0]?.name,
      entityId: id,
    });
    if (value?.success) {
      initialEditState.tournamentName = editData.tournamentName;
      const teams = uniqBy([...(value?.teams || []), ...(editData.teams || [])], "_id");
      initialEditState.selectedEditTeams = teams
        ?.filter((team) => editData?.teams?.some(({ teamId }) => teamId === team?.teamId))
        ?.map(({ name }) => name);
      setTeamsEdit(teams);
    }
    setIsEditOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const closeCSVModal = () => {
    setcsvIsOpen(false);
  };
  const closeEdit = () => {
    setIsEditOpen(false);
  };

  const delOpen = (id) => {
    setDeleteId(id);
    setDeleteModalOpen(true);
  };

  const delclose = () => {
    setDeleteModalOpen(false);
  };
  const setEventFun = async (event) => {
    const categoryId = await getCategorys?.filter((data) => data.name == event);
    if (categoryId && categoryId.length > 0) {
      const { value } = await getAllTeams({
        category: categoryId[0]?.name,
        search: teamSearch,
        entityId: id,
        pageNo: 1,
      });
      setTeams(value?.teams);
    }
  };

  const onChangeTournament = async (event) => {
    setCategory(event);
    const categoryId = await getCategorys?.filter((data) => data.name == event);

    setSelectCategory(event);
    if (categoryId && categoryId?.length > 0) {
      await getTournaments({
        categories: [categoryId[0]?.name],
        search: search,
        pageNo: activePage,
        limit,
        entityId: id,
      });
    }
  };
  const deleteTournamentModel = async () => {
    setTournamentLoader(true);
    const { value } = await getDeleteTournament({
      _id: deleteId?._id,
      entityId: id,
    });
    if (value.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    onChangeTournament(selectCategory);
    setTournamentLoader(false);
    handlePageChange(1);
    delclose();
    amplitude.logEvent("tournament_deleted", { tournament_id: deleteId?._id });
  };

  const [initialState, setInitialState] = useState({
    event: "",
    tournamentName: "",
    selectedTeams: [],
  });

  const [initialEditState] = useState({
    tournamentName: "",
    selectedEditTeams: [],
    event: "",
  });

  const handleSubmit = async ({ event, tournamentName, selectedTeams }) => {
    // name, tournamentName, teams, categoryId, organizationId
    const categoryId = await getCategorys?.filter((data) => data.name == event);
    const teamsId = (await teams) && teams?.filter((data) => selectedTeams.includes(data.name));
    const { value } = await getCreateTournament({
      // sportName: event,
      sportName: categoryId[0]?.name,
      tournamentName: tournamentName,
      entityId: id,
      teams: teamsId.map(({ _id }) => _id),
      // categoryName: categoryId[0].name || "",
    });
    if (value?.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }
    closeModal();
    setActivePage(1);
    onChangeTournament(event);
    amplitude.logEvent("add_tournament", { sport: event, tournament: tournamentName, teams: selectedTeams });
  };
  const handleSubmitEdit = async ({ tournamentName, selectedEditTeams }) => {
    const teamsId = (await teamsEdit) && teamsEdit?.filter((data) => selectedEditTeams.includes(data.name));
    const { value } = await getEditTournament({
      tournamentName: tournamentName,
      _id: editData?._id,
      entityId: id,
      teamIds: teamsId.map(({ _id }) => _id),
    });
    if (value?.success) {
      notification["success"]({ message: value.message });
    } else {
      notification["error"]({ message: value.message });
    }

    closeEdit();
    onChangeTournament(selectCategory);
    amplitude.logEvent("edit_tournament", { tournament: tournamentName, teams: selectedEditTeams });
  };
  const onChangeEvent = (value, setFieldValue) => {
    setFieldValue("event", value);
    setEventFun(value);
    // setCategory(value);
  };

  const openModal = () => {
    setInitialState({ ...initialState, event: selectCategory });
    setEventFun(selectCategory);
    setIsOpen(true);
    amplitude.logEvent("add_tournament_clicked");
  };

  const openCSVModal = () => {
    setcsvIsOpen(true);
    amplitude.logEvent("upload_tournament_csv_clicked");
  };

  const onFileDrop = async (files) => {
    let data = new FormData();
    data.append("file", files[0]);
    data.append("filename", files[0].name);
    data.append("userId", localStorage.getItem("__uid"));

    //call api here
    const { value } = await addBulkTournament(data);
    value.status
      ? notification["success"]({ message: "Tournaments added successfully!" })
      : notification["error"]({ message: value.message });
    onChangeTournament(category);
    setcsvIsOpen(false);
    amplitude.logEvent("tournament_csv_uploaded");
  };

  const tableAction = (data) => (
    <Menu
      items={[
        {
          label: (
            <a
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                delOpen(data);
              }}
            >
              <DeleteIcon />
              <span>Delete</span>
              {loder == false ? (
                ""
              ) : (
                <Spin
                  size="large"
                  indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                  className="loader__full"
                ></Spin>
              )}
            </a>
          ),
          key: "0",
          disabled: data?.entityId !== id,
        },
      ]}
    />
  );
  //handle input search
  const onChangeSearch = async (e) => {
    setActivePage(1);
    setSearch(e.target.value);
    setCount(count + 1);
  };

  useEffect(() => {
    if (firstRef.current) {
      onChangeTournament(selectCategory);
      firstRef.current = false;
    } else {
      const timer = setTimeout(() => {
        onChangeTournament(selectCategory);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [count]);

  useEffect(() => {
    if (teamsRef.current) {
      setEventFun(selectCategory);
      teamsRef.current = false;
    } else {
      const timer = setTimeout(() => {
        setEventFun(selectCategory);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [teamSearch]);

  useEffect(() => {
    // if (sports?.[0]?.value) {
    setSelectCategory(getCategorys[0]?.name);
    onChangeTournament(getCategorys[0]?.name);
    // }
  }, [getCategorys]);

  const handlePageChange = (current) => {
    setActivePage(current);
    // setEnd(current * settingsRecordsPerPage);
    // setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
    amplitude.logEvent("tournament_pagination", { page: current });
  };
  useEffect(() => {
    if (selectCategory) {
      onChangeTournament(selectCategory);
    }
  }, [activePage, selectCategory]);

  const handleSelectCategory = (e) => {
    setActivePage(1);
  };

  const getAllCategorys = async () => {
    if (id) {
      const { value } = await getAllCategory({
        entityId: id,
      });
      if (value?.success) {
        let assignCategories = value?.data?.filter((data) => selectedCategories?.includes(data?.name));
        setCategorys(assignCategories || []);
      }
    }
  };
  useEffect(() => {
    if (selectedCategories) getAllCategorys();
  }, [selectedCategories]);
  return (
    <>
      <DeleteModal
        deleteComanModel={deleteTournamentModel}
        loder={tournamentLoader}
        modalIsOpen={delmodalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        header="Delete"
        content="Are you sure you want to delete?"
      />

      {/* <UploadCSVModal
        csvmodalIsOpen={csvmodalIsOpen}
        closeCSVModal={closeCSVModal}
        loader={loder}
        url={"https://d32mvsvsusj3sv.cloudfront.net/csv/tournament.csv"}
        onFileDrop={onFileDrop}
      /> */}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <Formik
          initialValues={initialState}
          validationSchema={addTournamentValidation}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ errors, touched, setFieldValue, values }) => (
            <div className="modal-content">
              <Form>
                <AccessControl code="add_tournament" page="organization-profile">
                  <div className="react-modal-header">
                    <h5 className="react-modal-title">Add Tournament</h5>
                    <button type="button" onClick={closeModal} className="btn btn__default">
                      <CloseModal />
                    </button>
                  </div>
                </AccessControl>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Category <span className="required">*</span>
                      </label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="event"
                          showSearch
                          onChange={(value) => onChangeEvent(value, setFieldValue)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          // defaultValue={selectCategory || "select category"}
                          value={values.event}
                        >
                          {getCategorys.length &&
                            getCategorys.map((data, index) => {
                              return (
                                <>
                                  <Option key={data?._id} value={data.name}>
                                    {data?.displayName}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.event && errors.event && <div className="invalid-feedback">{errors.event}</div>}
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Tournament Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="tournamentName" type="text" />
                      {touched.tournamentName && errors.tournamentName && (
                        <div className="invalid-feedback">{errors.tournamentName}</div>
                      )}
                    </div>
                    <div className="form-group">
                      <label className="form-label">Teams</label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="selectedTeams"
                          onChange={(value) => setFieldValue("selectedTeams", value)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          mode="multiple"
                          placeholder="Select Team"
                          showSearch
                          onSearch={(value) => {
                            // Handle search logic here
                            setTeamSearch(value);
                            // You may want to trigger an API call to get filtered data based on the search value
                          }}
                          onBlur={() => {
                            setTeamSearch("");
                          }}
                        >
                          {teams &&
                            teams?.map((data, index) => {
                              return (
                                <>
                                  <Option key={index} value={data.name}>
                                    {data.name}
                                  </Option>
                                </>
                              );
                            })}
                        </Field>
                        {touched.selectedTeams && errors.selectedTeams && (
                          <div className="invalid-feedback">{errors.selectedTeams}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeModal}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary fill ms-3">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </Modal>
      <Modal
        isOpen={isEditOpen}
        onRequestClose={closeEdit}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Edit Tournament</h5>
            <button type="button" onClick={closeEdit} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik
            initialValues={initialEditState}
            validationSchema={editTournamentValidation}
            onSubmit={handleSubmitEdit}
          >
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Tournament Name <span className="required">*</span>
                      </label>
                      <Field className="form-control" name="tournamentName" type="text" />
                      {touched.tournamentName && errors.tournamentName && (
                        <div className="invalid-feedback">{errors.tournamentName}</div>
                      )}
                    </div>
                    <div className="field-items">
                      <label className="form-label">Teams</label>
                      <div className="form-pop-trigger-block">
                        <Field
                          className="custom-ant-select"
                          name="selectedEditTeams"
                          onChange={(value) => setFieldValue("selectedEditTeams", value)}
                          component={Select}
                          dropdownStyle={{ zIndex: 99999999 }}
                          showSearch
                          mode="multiple"
                          value={values?.selectedEditTeams}
                          onSearch={(value) => {
                            // Handle search logic here
                            setTeamSearch(value);
                            // You may want to trigger an API call to get filtered data based on the search value
                          }}
                          onBlur={() => {
                            setTeamSearch("");
                          }}
                        >
                          {teamsEdit &&
                            teamsEdit?.map((data) => {
                              return (
                                <>
                                  <Option value={data.name}>{data.name}</Option>
                                </>
                              );
                            })}
                        </Field>
                        {/* {touched.selectedEditTeams && errors.selectedEditTeams && (
                          <div className="invalid-feedback">{errors.selectedEditTeams}</div>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="react-modal-footer">
                  <div className="react-foo-container">
                    <div className="right-btn-block text-center">
                      <button type="button" className="btn btn-white" onClick={closeEdit}>
                        Cancel
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Add
                        {loder == false ? (
                          ""
                        ) : (
                          <Spin
                            size="large"
                            indicator={<LoadingOutlined style={{ fontSize: 50, color: "#000", marginLeft: 50 }} spin />}
                            className="loader__full"
                          ></Spin>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>

      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Tournament</h4>
            <p>Entertainment, Sports, News</p>
          </div>
          <AccessControl code="add_tournament" page="organization-profile">
            <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
              <div className="right-btn-block">
                <div class="button-container">
                  {/* <button class="btn btn-white me-3" onClick={openCSVModal}>
                  Upload a CSV file
                </button> */}
                  <button class="btn btn-primary" onClick={openModal} disabled={disallowRosterMutation}>
                    Add Tournament
                  </button>
                </div>
              </div>
            </ManageAccess>
          </AccessControl>
        </div>
        <div className="form-group main-space">
          <label className="form-label"> Select Category </label>
          <Select
            className="custom-ant-select"
            showSearch
            value={selectCategory}
            placeholder="Select Sport"
            onChange={(e) => {
              setSelectCategory(e);
              handleSelectCategory();
              onChangeTournament(e);
              setSearch("");
              amplitude.logEvent("tournament_category_selected", { category: e });
            }}
          >
            {getCategorys?.length &&
              getCategorys?.map((data, index) => {
                return (
                  <>
                    <Option key={data?._id} value={data.name}>
                      {data?.displayName}
                    </Option>
                  </>
                );
              })}
          </Select>
        </div>

        <div className="row mb-4 justify-content-end">
          <div className="col-md-6">
            <h5 className="title-small mb-0">Added Tournament</h5>
          </div>
          <div className="col-md-6">
            <div className="page-toolbar-styled-item">
              <input
                type="text"
                value={search}
                onChange={(e) => onChangeSearch(e)}
                placeholder="Search Tournament"
                className="form-control filters-search-control"
              />
            </div>
          </div>
        </div>
        <div className="configuration-items-row row">
          {tournamentList &&
            tournamentList?.map((data) => {
              return (
                <>
                  <div className="col-md-2">
                    <div className="confi-block-col-container configuration-column flex-column gap-0 p-2">
                      {/* <AccessControl code="delete_tournament" page="configuration">
                        <ManageAccess value={data?.organizationId == entityId}>
                          <Dropdown
                            className=""
                            overlay={tableAction(data)}
                            trigger={["click"]}
                            overlayClassName={"tableActionBlock"}
                            placement={"bottomRight"}
                          >
                            <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                              <TdiVerticalDark />
                            </a>
                          </Dropdown>
                        </ManageAccess>
                      </AccessControl> */}
                      {/* <div className="icon-block">
                        <VideoGroup />
                      </div> */}
                      <div className="confi-block-col">
                        <h4 className="word-break-common">
                          {data?.tournamentName
                            .split(" ")
                            .map((letter, index) => letter.charAt(0).toUpperCase() + letter.slice(1).toLowerCase())
                            .join(" ")}
                        </h4>
                        <h6>{convertIsoDateToStandardFormat(data?.updatedAt)}</h6>
                      </div>
                      {/* <AccessControl code="edit_tournament" page="configuration">
                        <ManageAccess value={data?.organizationId == entityId}>
                          <div className="btn-action">
                            <button
                              className="btn btn-edit btn-primary"
                              onClick={() => {
                                openEdit(data);
                              }}
                            // disabled={data?.organizationId !==organizationId}
                            >
                              Edit
                            </button>
                          </div>
                        </ManageAccess>
                      </AccessControl> */}
                      <div className="action-buttons gap-3">
                        <AccessControl code="edit_tournament" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button disabled={disallowRosterMutation}>
                              <EditIcon
                                onClick={() => {
                                  openEdit(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                        <AccessControl code="delete_tournament" page="organization-profile">
                          <ManageAccess value={getEntityTypes(id) !== ENTITY_TYPE.WORKSPACES}>
                            <button disabled={disallowRosterMutation}>
                              <Delete
                                onClick={() => {
                                  delOpen(data);
                                }}
                              />
                            </button>
                          </ManageAccess>
                        </AccessControl>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
        <ManageAccess value={tournamentCount?.length == 0}>
          <div className="col-md-12">
            <div className="w-100 text-center py-5">
              <h4>No Data Found!</h4>
            </div>
          </div>
        </ManageAccess>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={limit}
          onChange={handlePageChange}
          total={tournamentCount}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddTournaments;
